/**
 * Titre de tâche calculé (ADR-147 §3), comme `pages/change-task-name` du v1 : quand une réponse citée
 * par le titre de l'étape change, le web envoie ces réponses à `RefreshWorkItemTitle` ; le serveur évalue
 * l'expression et range le titre que la liste des tâches sert. Le client ne calcule rien : il dit
 * seulement quelles réponses comptent. Même règle à la tablette (`work_item_title.dart`).
 */

type DynamicTitle = { expression?: Readonly<Record<string, unknown>>; references?: ReadonlyArray<{ answer: string }> };

/** Réponses lues par le titre : celles des références et celles que l'expression cite par `$answers.<champ>`. */
export function titleAnswerFields(dynamic: DynamicTitle | undefined): string[] {
  if (dynamic === undefined) return [];
  const fields = new Set((dynamic.references ?? []).map((reference) => reference.answer));
  const visit = (node: unknown): void => {
    if (typeof node === 'string') {
      const match = /^\$answers\.([a-z][a-z0-9_]*)/.exec(node);
      if (match !== null) fields.add(match[1]!);
    } else if (Array.isArray(node)) node.forEach(visit);
    else if (node !== null && typeof node === 'object') Object.values(node).forEach(visit);
  };
  visit(dynamic.expression ?? {});
  return [...fields].sort();
}

/** Clé des réponses citées : un titre ne se redemande que si elle change ; `null` quand aucune n'est renseignée. */
export function titleAnswersKey(fields: readonly string[], answers: Readonly<Record<string, unknown>>): string | null {
  const picked = Object.fromEntries(fields.filter((field) => answers[field] !== undefined && answers[field] !== null && answers[field] !== '').map((field) => [field, answers[field]]));
  return Object.keys(picked).length === 0 ? null : JSON.stringify(picked);
}
